import AccessControl from "@components/AccessControl";

import { useMentionCard } from "../../../context";
import Cover from "../../Cover";
import Favorite from "../../Favorite";
import Footer from "../../Footer";
import Header from "../../Header";
import MetaActions from "../../MetaActions";
import PaywallNotice from "../../PaywallNotice";
import ShareEpisode from "../../ShareEpisode";
import TextMentions from "./TextMentions";

import styles from "./Text.module.css";

const TextMentionCardBody = () => {
  const {
    hideActions,
    can_mark_favorite,
    channel: { channel_type: source, artwork_url: channelCover },
    episode: {
      artwork_url: episodeCover,
      external_media_source: episodeUrl,
      guid: episodeGuid,
    },
  } = useMentionCard();

  const cover = episodeCover || channelCover;

  return (
    <div className={styles.root} data-testid="text-episode">
      <div className={styles.top}>
        <div className={styles.inner}>
          <Header />
          <PaywallNotice />
          <MetaActions />
          <TextMentions />
        </div>

        <div className={styles.cover}>
          <Cover
            source={source}
            cover={cover}
            episodeUrl={episodeUrl}
            episodeGuid={episodeGuid}
          />
          {!hideActions && can_mark_favorite && (
            <AccessControl>
              <Favorite className={styles.favorite} />
            </AccessControl>
          )}
          <ShareEpisode className={styles.share} />
        </div>
      </div>
      <Footer className={styles.footer} />
    </div>
  );
};

export default TextMentionCardBody;
